let cachedConfig = null;
let pendingConfig = null;

export const getPublicConfig = async () => {
  if (cachedConfig) return cachedConfig;

  if (!pendingConfig) {
    pendingConfig = fetch('/crm/config', { headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? response.json() : {}))
      .catch(() => ({}))
      .then((config) => {
        cachedConfig = { turnstileSiteKey: config.turnstileSiteKey || null };
        return cachedConfig;
      })
      .finally(() => {
        pendingConfig = null;
      });
  }

  return pendingConfig;
};
